import { Divider } from '@almbrand/divider';
import { Headline } from '@almbrand/headline';
import { Modal } from '@almbrand/modal';
import { Paragraph } from '@almbrand/paragraph';
import React from 'react';
import { CURRENCY_MONTHLY_SHORT } from '../Basket';
import { BasketDetailsItem, BasketItemDetails } from '../Basket.types';
import styles from './ProductDetailsModal.module.scss';

export interface ProductDetailsModalProps {
	details: BasketItemDetails;
	price?: number;
	onClose: () => void;
}

const Section = ({ heading, items }: { heading: string; items: BasketDetailsItem[] }) => (
	<div className={styles.ProductDetailsModal__section}>
		<Paragraph
			className={styles.ProductDetailsModal__sectionHeading}
			text={heading}
			paragraphType={{ kind: 'title', type: 'standfirst' }}
		/>
		<ul className={styles.ProductDetailsModal__rows}>
			{items.map(({ label, value }) => (
				<li
					key={label}
					className={styles.ProductDetailsModal__row}
				>
					<Paragraph
						className={styles.ProductDetailsModal__rowLabel}
						text={label}
						paragraphType={{ kind: 'label', size: 'default' }}
						fontColor='primaryDark'
					/>
					<Paragraph
						className={styles.ProductDetailsModal__rowValue}
						text={value}
						paragraphType={{ kind: 'label', size: 'default' }}
						fontColor='primary'
					/>
				</li>
			))}
		</ul>
	</div>
);

export const ProductDetailsModal: React.FC<ProductDetailsModalProps> = ({ details, price, onClose }) => {
	const { heading, totalAmountText, modalTitlePrefix, productTitle, detailsCloseBtnLabel } = details;

	return (
		<Modal
			title={`${modalTitlePrefix} ${productTitle}`}
			handleClose={onClose}
			ariaClose={detailsCloseBtnLabel}
			mode='default'
			mobileVariation='default'
			role='dialog'
		>
			<div className={styles.ProductDetailsModal__content}>
				<Headline
					className={styles.ProductDetailsModal__heading}
					title={heading}
					variant='h2'
					size='default'
				/>

				{details.sections.map((section, index) => (
					<React.Fragment key={section.type}>
						<Section
							heading={section.heading}
							items={section.items}
						/>
						{/* Divider between sections, except after the last section */}
						{index < details.sections.length - 1 && (
							<Divider
								dividerType='tertiary'
								margin='x-small'
							/>
						)}
					</React.Fragment>
				))}

				{price !== undefined && (
					<div className={styles.ProductDetailsModal__total}>
						<Paragraph
							className={styles.ProductDetailsModal__rowLabel}
							text={totalAmountText}
							paragraphType={{ kind: 'label', size: 'default' }}
							fontColor='primaryDark'
						/>
						<Paragraph
							className={styles.ProductDetailsModal__rowValue}
							text={`${price} ${CURRENCY_MONTHLY_SHORT}`}
							paragraphType={{ kind: 'label', size: 'default' }}
							fontColor='primary'
						/>
					</div>
				)}
			</div>
		</Modal>
	);
};
